import React from "react";
import styled from "styled-components";
import { Icon } from "@fluentui/react";
export const StyledWrapper = styled.div`
  display: flex;
  align-items:  center;
  width: 100%;
  min-height: 55px;
  flex-direction:column;
`;

export const StyledImage = styled.img`
  object-fit: cover;
  height: 50%;
  width: 50%;
`;

export const SchedularWrapper = ({ item, tasks }) => {
  return (
    <StyledWrapper
      title={item.title}
      rows={tasks}
      onClick={() => { }}>
      {item.icon ? (
        <StyledImage src={item.icon} alt="Icon"></StyledImage>
      ) : (
        <Icon iconName="contact" style={{ height: 16 }} />
      )}
      {item.title}
    </StyledWrapper>
  );
};
